import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressSpinnerModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabProductsComponent } from './tab-products.component';

@NgModule({
  declarations: [
    TabProductsComponent
  ],
  imports: [
    PipesModule,
    TranslateModule,
    FuseSharedModule,
    ReactiveFormsModule,

    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule
  ],
  exports: [
    TabProductsComponent
  ]
})
export class TabProductsModule { }
